import { Component, OnInit, inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-pwa-prompt',
  templateUrl: './pwa-prompt.component.html',
  styleUrls: ['./pwa-prompt.component.sass'],
  imports: [MatToolbar, MatButton, MatIconButton, MatIcon],
})
export class PwaPromptComponent implements OnInit {
  data = inject<{
    mobileType: 'ios' | 'android';
    promptEvent?: any;
  }>(MAT_BOTTOM_SHEET_DATA);
  private bottomSheetRef = inject<MatBottomSheetRef<PwaPromptComponent>>(MatBottomSheetRef);

  ngOnInit(): void {}

  public installPwa(): void {
    this.data.promptEvent.prompt();
    this.close();
  }

  public close() {
    this.bottomSheetRef.dismiss();
  }
}
